// GLOBAL
var $menu = $('.js-menu'),
    $menuTrigger = $('.js-menuTrigger'),
    $nav = $('.js-nav'),
    $menuSubMenuParent =  $nav.find('.menu-item-has-children'),
    $menuSubMenuTrigger =  $nav.find('.menu-item-has-children > a'),
    $menuSubMenu =  $nav.find('.sub-menu');

tetloose.menu = function () {
    $menuTrigger.on('click', function(e) {
        e.preventDefault();
        if ( $menu.hasClass('is-active') ) {
            tetloose.closeMenu();
            return false;
        }
        tetloose.openMenu();
    });

    $menuSubMenuTrigger.on('click', function(e) {
        e.preventDefault();

        var $t = $(this),
            $parent = $t.parent(),
            $parents = $t.parents();

        if ($parent.hasClass('hover')) {
            tetloose.closeSubMenu();
            return false;
        }
        tetloose.closeSubMenu();
        $parent.addClass('hover');
    });
};

tetloose.openMenu = function () {
    $menu.addClass('is-active');
    $menuTrigger.addClass('is-active');
    $html.addClass('no-scroll');
};

tetloose.closeMenu = function () {
    $menu.removeClass('is-active');
    $menuTrigger.removeClass('is-active');
    $html.removeClass('no-scroll');
};

tetloose.closeSubMenu = function () {
    $menuSubMenuParent.removeClass('hover');
};
